// ReasonModal — 1:1 port of legacy `src/ui/ReasonModal.jsx`.
// Confirm + required reason textarea (min-length 3 trims-then-counts).
import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button.js';
import { Modal } from './Modal.js';
import { Textarea } from './Textarea.js';

export interface ReasonModalProps {
  title: string;
  text?: ReactNode;
  placeholder?: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

export function ReasonModal({
  title,
  text,
  placeholder,
  confirmLabel,
  danger,
  onConfirm,
  onClose,
}: ReasonModalProps) {
  const { t } = useTranslation('common');
  const [value, setValue] = useState('');
  const canSubmit = value.trim().length >= 3;
  const resolvedPlaceholder = placeholder ?? t('fields.reasonPlaceholder');
  const resolvedConfirmLabel = confirmLabel ?? t('actions.confirm');
  return (
    <Modal
      open={true}
      onClose={onClose}
      title={title}
      width={460}
      footer={
        <>
          <Button kind="ghost" onClick={onClose}>
            {t('actions.cancel')}
          </Button>
          <Button
            kind={danger ? 'danger' : 'primary'}
            disabled={!canSubmit}
            onClick={() => {
              onConfirm(value.trim());
              onClose();
            }}
          >
            {resolvedConfirmLabel}
          </Button>
        </>
      }
    >
      {text && (
        <div style={{ color: 'var(--fg-2)', fontSize: 13, marginBottom: 10, lineHeight: 1.55 }}>
          {text}
        </div>
      )}
      <Textarea value={value} onChange={setValue} placeholder={resolvedPlaceholder} rows={4} />
      {!canSubmit && (
        <div style={{ fontSize: 11, color: 'var(--fg-3)', marginTop: 6 }}>
          {t('states.minimumReason')}
        </div>
      )}
    </Modal>
  );
}
